// extracted by mini-css-extract-plugin
export default {"background":"styles_background__CaK3f","wrapper":"styles_wrapper__le9eq","error":"styles_error__Xv96L","msg":"styles_msg__7WVPx","link":"styles_link__6tiw5"};